"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeDefaultProps = exports.badgeColors = exports.BORDER_RADIUS = exports.BADGE_SIZE = void 0;

var _interfaces = require("./interfaces");

var badgeDefaultProps = {
  colorScheme: _interfaces.BadgeColorScheme.Default,
  type: _interfaces.BadgeType.Default // variant: BadgeVariant.Text

};
exports.badgeDefaultProps = badgeDefaultProps;
var BADGE_SIZE = 16;
exports.BADGE_SIZE = BADGE_SIZE;
var BORDER_RADIUS = 'R1000';
exports.BORDER_RADIUS = BORDER_RADIUS;
var badgeColors = {
  default: {
    default: {
      backgroundColor: 'pink70',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'pink50',
      textColor: 'neutral100'
    }
  },
  primary: {
    default: {
      backgroundColor: 'primary70',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'primary50',
      textColor: 'neutral100'
    }
  },
  neutral: {
    default: {
      backgroundColor: 'neutral70',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'neutral20',
      textColor: 'neutral100'
    }
  },
  positive: {
    default: {
      backgroundColor: 'green70',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'green50',
      textColor: 'neutral100'
    }
  },
  warning: {
    default: {
      backgroundColor: 'yellow80',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'yellow50',
      textColor: 'neutral100'
    }
  },
  negative: {
    default: {
      backgroundColor: 'red70',
      textColor: 'neutral0'
    },
    darkBackground: {
      backgroundColor: 'red50',
      textColor: 'neutral100'
    }
  }
};
exports.badgeColors = badgeColors;